export const pageContentQuery = (pageType, contentBuilderKey, contentBuilderFragment) => {
    return `query pageContent($canonicalUid: String) {
        entry(uid: [$canonicalUid]) {
            ... on ${pageType} {
                ${contentBuilderKey} {
                    __typename
                    ${contentBuilderFragment}
                }
            }
        }
    }`
}